import { motion } from 'framer-motion';
import { Shield, Eye, UserCheck, Flag } from 'lucide-react';

export default function Safety() {
    const safetyFeatures = [
        {
            icon: Shield,
            title: 'Pre-Reviewed Dares',
            description: 'All dares reviewed for safety before launch',
        },
        {
            icon: Eye,
            title: 'AI + Human Moderation',
            description: 'Advanced content moderation on every video',
        },
        {
            icon: UserCheck,
            title: 'Age-Appropriate',
            description: '13+ with clear safety guidelines',
        },
        {
            icon: Flag,
            title: 'Report & Block',
            description: 'Easy tools to report and block content',
        },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-green-500/20 border border-green-500/50 rounded-full mb-6">
                        <Shield className="w-10 h-10 text-green-400" />
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">
                        Safe, Fun, and Responsible
                    </h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                        Your safety and privacy are our top priorities
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
                    {safetyFeatures.map((feature, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="text-center"
                        >
                            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl mb-4 shadow-lg">
                                <feature.icon className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="font-display text-lg font-bold text-white mb-2">{feature.title}</h3>
                            <p className="text-gray-400 text-sm">{feature.description}</p>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-center mt-16 max-w-3xl mx-auto"
                >
                    <div className="bg-dark-800 border border-dark-700 rounded-2xl p-8 shadow-lg">
                        <p className="text-gray-300 leading-relaxed">
                            <strong className="text-white">Safety First:</strong> We carefully review every dare before
                            it goes live. Our platform is built with comprehensive moderation tools, age verification,
                            and clear community guidelines to ensure a safe and positive experience for everyone.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
